// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Campaign planner */
.BC-Page__CampaignPlanner .Polaris-Page-Header {
  padding-bottom: 0;
}

.BC-Page__CampaignPlanner .Polaris-DisplayText.Polaris-DisplayText--sizeSmall {
  font-weight: 600;
  font-size: 16px;
  margin-top: 16px;
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Content {
  margin-top: 4px
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Image {
  width: 160px;
  height: 100px;
  margin: 0 auto;
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Actions .Polaris-Button__Text {
  font-weight: 500;
}

/* List/Calendar view toggle */
.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle {
  display: flex;
  width: fit-content;
  padding: 4px;
  background: #edeeef;
  border-radius: 4px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
  margin: 24px 0;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment {
  width: 85px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: #202223;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment--active {
  background: #fff;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08), inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);
}

/* Campaign table */
.BC-Page__CampaignPlanner .BC-Filters .BC-Filters-ConnectedFilterControl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  padding-bottom: 0;
  border-bottom: var(--p-border-divider);
}

.BC-Page__CampaignPlanner .BC-Filters .Polaris-Tabs__Wrapper {
  border-bottom: none;
  padding: 0;
}

.BC-Page__CampaignPlanner .Polaris-Tabs__TabContainer .Polaris-Tabs__Tab:focus-visible {
  outline: -webkit-focus-ring-color auto 1px;
}

.BC-Page__CampaignPlanner .BC-Filters .search {
  width: 300px;
}

.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__LeftContainer {
  flex: 1 1 auto;
}

.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__RightContainer {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: end;
}

.BC-Page__CampaignPlanner .Polaris-DataTable {
  padding: 20px;
}

.BC-Page__CampaignPlanner .Polaris-DataTable thead {
  background: #FAFBFB;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header {
  padding: 12px 16px;
  border-top: 1px solid #E1E3E5;
  font-weight: 600;
  color: #6D7175;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid #E1E3E5;
  width: 215px;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid #E1E3E5;
  width: 135px;
  text-align: center;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child {
  text-align: center;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Button--outline {
  border-color: #008060;
  color: #008060;
  padding: 5px 12px;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell .Polaris-DataTable__TooltipContent {
  white-space: initial;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-TabNote {
  margin: 20px 20px 0;
  padding: 16px;
  background: #EBF9FC;
  border-radius: 4px;
  border: 1px solid #98C6CD;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-Pagination {
  display: flex;
  justify-content: center;
  padding: 16px 0;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CampaignLink {
  color: #2c6ecb;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon {
  display: inline-flex;
  position: relative;
  width: 20px;
  height: 20px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon__Badge {
  position: absolute;
  top: -4px;
  right: -6px;
  width: 12px;
  height: 12px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon__NeedsSetup path {
  fill: #BABEC3;
}

.BC-CampaignPlanner-FeatureIconTooltip {
  background-color: #fff !important;
  border-radius: 4px;
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  padding: 4px 8px !important;
  color: #202223 !important;
}

.BC-CampaignPlanner-FeatureIconTooltip::before,
.BC-CampaignPlanner-FeatureIconTooltip::after {
  display: none;
}

.BC-Page__CampaignPlanner .actionsGroup {
  text-align: right;
  margin-top: 24px;
}

.BC-CampaignPlanner-Loading {
  padding: 20px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 80px 20px;
  text-align: center;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Heading {
  font-size: 16px;
  font-weight: 600;
  color: #202223;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Body {
  font-size: 14px;
  color: #6d7175;
}

/* Campaign planner - create campaign wizard */
.BC-Page__CampaignPlannerNew .content {
  max-width: 936px;
  margin: 32px auto;
  margin-top: 40px;
}

.BC-Page__CampaignPlannerNew .content .BC-CampaignPlanner-AddRulesModal__Loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0;
  height: calc(100vh - 108px);
}

.BC-Page__CampaignPlannerNew .content .BC-CampaignPlanner-AddRulesModal__Loading .Polaris-Spinner {
  display: inline-flex;
  height: 48px;
}

.BC-Page__CampaignPlannerNew .content .Polaris-Label__Text {
  font-weight: 600;
}

.BC-CampaignPlannerNew-ScheduleLabel {
  display: flex;
  align-items: center;
  gap: 4px;
}

.BC-CampaignPlannerNew-ScheduleLabel>span {
  display: inline-flex;
  align-items: center;
}

.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon {
  display: inline-flex;
  cursor: pointer;
}

.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon .Polaris-Icon__Svg {
  fill: #5c5f62;
}

/* css override Polaris tooltip default 200px */
[class*='Polaris-Tooltip-TooltipOverlay__Content']:has(> .BC-CampaignPlannerNew-ScheduleTooltip),
[class*='Polaris-Tooltip-TooltipOverlay__Content']:has(> .BC-CampaignPlanner-CustomRangeTooltip) {
  max-width: 487px !important;
}

.BC-CampaignPlannerNew-ScheduleOptions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.BC-CampaignPlannerNew-ScheduleFields {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 8px;
  padding: 12px;
  background: #f6f6f7;
  border-radius: 8px;
}

.BC-Page__CampaignPlannerNew__Date-picker-container {
  max-width: 360px;
}

.BC-CampaignPlanner-TimeField {
  position: relative;
}

.BC-CampaignPlanner-TimeField input[type="time"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}

@media (max-width: 768px) {
  .BC-CampaignPlannerNew-ScheduleFields {
    grid-template-columns: repeat(2, 1fr);
  }
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}



.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow {
  padding: 12px 16px;
  background: #f6f6f7;
  border-radius: 8px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: none;
  background: #fff;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon.BC-CampaignPlannerNew-FeatureRow__Icon--complete svg g {
  fill: #007F5F;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon.BC-CampaignPlannerNew-FeatureRow__Icon--incomplete svg g {
  fill: #B98900;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Text {
  flex: 1 1 auto;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Title {
  font-weight: 600;
  color: #202223;
  font-size: 16px;
  margin-bottom: 2px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Title .Polaris-Badge--statusInfo {
  background-color: #E0F0FF;
  color: #00527C;
  font-weight: 500;
  margin-left: 4px;
  font-size: 12px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Description {
  font-size: 12px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItems {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid #e1e3e5;
  border-radius: 8px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem .Polaris-Button {
  padding: 3px;
  min-width: auto;
  min-height: auto;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Action .Polaris-Button {
  padding: 6px 12px;
  min-width: auto;
  min-height: auto;
  font-weight: 500;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text {
  flex: 1 1 auto;
  padding-right: 16px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text .Polaris-Banner--statusWarning {
  background-color: #FFF5EA;
  padding: 8px;
  font-size: 12px;
  border-radius: 4px;
  margin-top: 8px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {
  padding-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Title {
  font-weight: 600;
  color: #202223;
  margin-bottom: 2px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Meta {
  font-size: 12px;
  color: #6D7175;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRows {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow {
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid transparent;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRowSkeleton {
  height: 64px;
  margin-top: 24px;
  border-radius: 8px;
  background: linear-gradient(90deg, #f1f2f3 25%, #e4e5e7 37%, #f1f2f3 63%);
  background-size: 400% 100%;
  animation: BC-CampaignPlannerNew-Skeleton-Shimmer 1.4s ease infinite;
  margin-top: 16px;
}

@keyframes BC-CampaignPlannerNew-Skeleton-Shimmer {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow--active {
  background: #F1F8F5;
  border-color: #95C9B4;
  margin-top: 24px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow--needsBlock {
  background: #FCF1E4;
  border-color: #F3D5AE;
  margin-top: 24px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow__Header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow .Polaris-Badge--statusSuccess {
  font-weight: 500;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide {
  margin-top: 20px;
  padding-left: 52px;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide .Polaris-Banner--statusWarning {
  box-shadow: none;
  background-color: transparent;
  padding: 0;
  color: #916A00;
}

.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {
  padding-right: 8px;
}

/* Add rules modal (rendered via Polaris Modal portal, so left unscoped) */
.BC-CampaignPlanner-AddRulesModal__List {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 280px;
  margin-top: 16px;
  overflow-y: auto;
}

.BC-CampaignPlanner-AddRulesModal__Item {
  padding: 8px 4px;
}

.BC-CampaignPlanner-AddRulesModal__Loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.BC-CampaignPlanner-AddRulesModal__Footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-top: 1px solid #e1e3e5;
}

.BC-CampaignPlanner-AddRulesModal__Empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  text-align: center;
}

.BC-CampaignPlanner-AddRulesModal__EmptyHeading {
  font-size: 14px;
  font-weight: 600;
  color: #202223;
}

.BC-CampaignPlanner-AddRulesModal__Empty img {
  width: 45px;
}

/* Edit rule schedule modal (rendered via Polaris Modal portal, so left unscoped) */
.BC-CampaignPlanner-EditScheduleModal__Label {
  margin-bottom: 8px;
}

.BC-CampaignPlanner-EditScheduleModal__Option {
  margin-bottom: 8px;
}

.BC-CampaignPlanner-EditScheduleModal__OptionLabel {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.BC-CampaignPlanner-EditScheduleModal__OptionLabel>span {
  display: inline-flex;
}

.BC-CampaignPlanner-EditScheduleModal__TooltipIcon {
  display: inline-flex;
  cursor: pointer;
}

.BC-CampaignPlanner-EditScheduleModal__CampaignRange {
  margin-left: 28px;
  font-size: 12px;
  color: #6d7175;
}

.BC-CampaignPlanner-EditScheduleModal__Fields {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 12px 0 12px 28px;
}

.BC-CampaignPlanner-EditScheduleModal__Warning {
  margin-left: 28px;
}

.BC-CampaignPlanner-EditScheduleModal__Warning .Polaris-Banner--statusWarning {
  background-color: transparent;
  padding: 0;
  outline: 0;
  box-shadow: none;
  color: #916A00;
}

.BC-CampaignPlanner-EditScheduleModal__Warning .Polaris-Banner__Ribbon {
  padding-right: 4px;
}

.BC-CampaignPlanner-EditScheduleModal__Option .BC-CampaignPlanner-EditScheduleModal__TooltipIcon .Polaris-Icon {
  width: 16px;
  height: 16px;
}

.BC-CampaignPlanner-EditScheduleModal__Option .BC-CampaignPlanner-EditScheduleModal__TooltipIcon .Polaris-Icon__Svg {
  fill: #5C5F62;
}`, "",{"version":3,"sources":["webpack://./src/styles/campaign-planner.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2FAA2F;AAC7F;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iEAAiE;EACjE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA,+CAA+C;AAC/C;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;;AAIA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,0BAA0B;EAC1B,oEAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":["/* Campaign planner */\n.BC-Page__CampaignPlanner .Polaris-Page-Header {\n  padding-bottom: 0;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DisplayText.Polaris-DisplayText--sizeSmall {\n  font-weight: 600;\n  font-size: 16px;\n  margin-top: 16px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Content {\n  margin-top: 4px\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Image {\n  width: 160px;\n  height: 100px;\n  margin: 0 auto;\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Actions .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n/* List/Calendar view toggle */\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle {\n  display: flex;\n  width: fit-content;\n  padding: 4px;\n  background: #edeeef;\n  border-radius: 4px;\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);\n  margin: 24px 0;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment {\n  width: 85px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  color: #202223;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment--active {\n  background: #fff;\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08), inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);\n}\n\n/* Campaign table */\n.BC-Page__CampaignPlanner .BC-Filters .BC-Filters-ConnectedFilterControl {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  padding-bottom: 0;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__CampaignPlanner .BC-Filters .Polaris-Tabs__Wrapper {\n  border-bottom: none;\n  padding: 0;\n}\n\n.BC-Page__CampaignPlanner .Polaris-Tabs__TabContainer .Polaris-Tabs__Tab:focus-visible {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters .search {\n  width: 300px;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__LeftContainer {\n  flex: 1 1 auto;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__RightContainer {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable {\n  padding: 20px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable thead {\n  background: #FAFBFB;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header {\n  padding: 12px 16px;\n  border-top: 1px solid #E1E3E5;\n  font-weight: 600;\n  color: #6D7175;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid #E1E3E5;\n  width: 215px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid #E1E3E5;\n  width: 135px;\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child {\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Button--outline {\n  border-color: #008060;\n  color: #008060;\n  padding: 5px 12px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell .Polaris-DataTable__TooltipContent {\n  white-space: initial;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-TabNote {\n  margin: 20px 20px 0;\n  padding: 16px;\n  background: #EBF9FC;\n  border-radius: 4px;\n  border: 1px solid #98C6CD;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-Pagination {\n  display: flex;\n  justify-content: center;\n  padding: 16px 0;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CampaignLink {\n  color: #2c6ecb;\n  font-size: 14px;\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon {\n  display: inline-flex;\n  position: relative;\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon__Badge {\n  position: absolute;\n  top: -4px;\n  right: -6px;\n  width: 12px;\n  height: 12px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon__NeedsSetup path {\n  fill: #BABEC3;\n}\n\n.BC-CampaignPlanner-FeatureIconTooltip {\n  background-color: #fff !important;\n  border-radius: 4px;\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  padding: 4px 8px !important;\n  color: #202223 !important;\n}\n\n.BC-CampaignPlanner-FeatureIconTooltip::before,\n.BC-CampaignPlanner-FeatureIconTooltip::after {\n  display: none;\n}\n\n.BC-Page__CampaignPlanner .actionsGroup {\n  text-align: right;\n  margin-top: 24px;\n}\n\n.BC-CampaignPlanner-Loading {\n  padding: 20px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #202223;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Body {\n  font-size: 14px;\n  color: #6d7175;\n}\n\n/* Campaign planner - create campaign wizard */\n.BC-Page__CampaignPlannerNew .content {\n  max-width: 936px;\n  margin: 32px auto;\n  margin-top: 40px;\n}\n\n.BC-Page__CampaignPlannerNew .content .BC-CampaignPlanner-AddRulesModal__Loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 24px 0;\n  height: calc(100vh - 108px);\n}\n\n.BC-Page__CampaignPlannerNew .content .BC-CampaignPlanner-AddRulesModal__Loading .Polaris-Spinner {\n  display: inline-flex;\n  height: 48px;\n}\n\n.BC-Page__CampaignPlannerNew .content .Polaris-Label__Text {\n  font-weight: 600;\n}\n\n.BC-CampaignPlannerNew-ScheduleLabel {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-CampaignPlannerNew-ScheduleLabel>span {\n  display: inline-flex;\n  align-items: center;\n}\n\n.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-CampaignPlannerNew-ScheduleLabel__TooltipIcon .Polaris-Icon__Svg {\n  fill: #5c5f62;\n}\n\n/* css override Polaris tooltip default 200px */\n[class*='Polaris-Tooltip-TooltipOverlay__Content']:has(> .BC-CampaignPlannerNew-ScheduleTooltip),\n[class*='Polaris-Tooltip-TooltipOverlay__Content']:has(> .BC-CampaignPlanner-CustomRangeTooltip) {\n  max-width: 487px !important;\n}\n\n.BC-CampaignPlannerNew-ScheduleOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.BC-CampaignPlannerNew-ScheduleFields {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-top: 8px;\n  padding: 12px;\n  background: #f6f6f7;\n  border-radius: 8px;\n}\n\n.BC-Page__CampaignPlannerNew__Date-picker-container {\n  max-width: 360px;\n}\n\n.BC-CampaignPlanner-TimeField {\n  position: relative;\n}\n\n.BC-CampaignPlanner-TimeField input[type=\"time\"]::-webkit-calendar-picker-indicator {\n  display: none;\n  -webkit-appearance: none;\n}\n\n@media (max-width: 768px) {\n  .BC-CampaignPlannerNew-ScheduleFields {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRows {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow {\n  padding: 12px 16px;\n  background: #f6f6f7;\n  border-radius: 8px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  flex: none;\n  background: #fff;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon.BC-CampaignPlannerNew-FeatureRow__Icon--complete svg g {\n  fill: #007F5F;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Icon.BC-CampaignPlannerNew-FeatureRow__Icon--incomplete svg g {\n  fill: #B98900;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Text {\n  flex: 1 1 auto;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Title {\n  font-weight: 600;\n  color: #202223;\n  font-size: 16px;\n  margin-bottom: 2px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Title .Polaris-Badge--statusInfo {\n  background-color: #E0F0FF;\n  color: #00527C;\n  font-weight: 500;\n  margin-left: 4px;\n  font-size: 12px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRow__Description {\n  font-size: 12px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItems {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 16px;\n  background: #fff;\n  border: 1px solid #e1e3e5;\n  border-radius: 8px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem .Polaris-Button {\n  padding: 3px;\n  min-width: auto;\n  min-height: auto;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Action .Polaris-Button {\n  padding: 6px 12px;\n  min-width: auto;\n  min-height: auto;\n  font-weight: 500;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text {\n  flex: 1 1 auto;\n  padding-right: 16px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text .Polaris-Banner--statusWarning {\n  background-color: #FFF5EA;\n  padding: 8px;\n  font-size: 12px;\n  border-radius: 4px;\n  margin-top: 8px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Text .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {\n  padding-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Title {\n  font-weight: 600;\n  color: #202223;\n  margin-bottom: 2px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-FeatureRuleItem__Meta {\n  font-size: 12px;\n  color: #6D7175;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRows {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow {\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRowSkeleton {\n  height: 64px;\n  margin-top: 24px;\n  border-radius: 8px;\n  background: linear-gradient(90deg, #f1f2f3 25%, #e4e5e7 37%, #f1f2f3 63%);\n  background-size: 400% 100%;\n  animation: BC-CampaignPlannerNew-Skeleton-Shimmer 1.4s ease infinite;\n  margin-top: 16px;\n}\n\n@keyframes BC-CampaignPlannerNew-Skeleton-Shimmer {\n  0% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow--active {\n  background: #F1F8F5;\n  border-color: #95C9B4;\n  margin-top: 24px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow--needsBlock {\n  background: #FCF1E4;\n  border-color: #F3D5AE;\n  margin-top: 24px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow__Header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableRow .Polaris-Badge--statusSuccess {\n  font-weight: 500;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide {\n  margin-top: 20px;\n  padding-left: 52px;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide .Polaris-Banner--statusWarning {\n  box-shadow: none;\n  background-color: transparent;\n  padding: 0;\n  color: #916A00;\n}\n\n.BC-Page__CampaignPlannerNew .BC-CampaignPlannerNew-EnableGuide .Polaris-Banner--statusWarning .Polaris-Banner__Ribbon {\n  padding-right: 8px;\n}\n\n/* Add rules modal (rendered via Polaris Modal portal, so left unscoped) */\n.BC-CampaignPlanner-AddRulesModal__List {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  max-height: 280px;\n  margin-top: 16px;\n  overflow-y: auto;\n}\n\n.BC-CampaignPlanner-AddRulesModal__Item {\n  padding: 8px 4px;\n}\n\n.BC-CampaignPlanner-AddRulesModal__Loading {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.BC-CampaignPlanner-AddRulesModal__Footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-top: 1px solid #e1e3e5;\n}\n\n.BC-CampaignPlanner-AddRulesModal__Empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  text-align: center;\n}\n\n.BC-CampaignPlanner-AddRulesModal__EmptyHeading {\n  font-size: 14px;\n  font-weight: 600;\n  color: #202223;\n}\n\n.BC-CampaignPlanner-AddRulesModal__Empty img {\n  width: 45px;\n}\n\n/* Edit rule schedule modal (rendered via Polaris Modal portal, so left unscoped) */\n.BC-CampaignPlanner-EditScheduleModal__Label {\n  margin-bottom: 8px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Option {\n  margin-bottom: 8px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__OptionLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__OptionLabel>span {\n  display: inline-flex;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__TooltipIcon {\n  display: inline-flex;\n  cursor: pointer;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__CampaignRange {\n  margin-left: 28px;\n  font-size: 12px;\n  color: #6d7175;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Fields {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  margin: 12px 0 12px 28px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Warning {\n  margin-left: 28px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Warning .Polaris-Banner--statusWarning {\n  background-color: transparent;\n  padding: 0;\n  outline: 0;\n  box-shadow: none;\n  color: #916A00;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Warning .Polaris-Banner__Ribbon {\n  padding-right: 4px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Option .BC-CampaignPlanner-EditScheduleModal__TooltipIcon .Polaris-Icon {\n  width: 16px;\n  height: 16px;\n}\n\n.BC-CampaignPlanner-EditScheduleModal__Option .BC-CampaignPlanner-EditScheduleModal__TooltipIcon .Polaris-Icon__Svg {\n  fill: #5C5F62;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
